import React, { useState } from "react";
import styles from "../styles/Navbar.module.css";
import logo from "../img/relico_logo.svg";
import { FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className={styles.navbar}>
      <div
        className={styles.nav_logo}
        onClick={() => {
          document
            .getElementById("home")
            ?.scrollIntoView({ behavior: "smooth" });
        }}
      >
        <img src={logo} alt="relico_logo" />
      </div>

      <div className={`${styles.nav_links} ${isOpen ? styles.active : ""}`}>
        <div className={styles.mobile_logo}>
          <img src={logo} alt="relico_logo" />
        </div>
        <a
          onClick={() => {
            document
              .getElementById("home")
              ?.scrollIntoView({ behavior: "smooth" });
            setIsOpen(false);
          }}
        >
          Home
        </a>
        <a
          onClick={() => {
            document
              .getElementById("about")
              ?.scrollIntoView({ behavior: "smooth" });
            setIsOpen(false);
          }}
        >
          About
        </a>
        <a
          onClick={() => {
            document
              .getElementById("core")
              ?.scrollIntoView({ behavior: "smooth" });
            setIsOpen(false);
          }}
        >
          Core Values
        </a>
        <a
          onClick={() => {
            document
              .getElementById("operating")
              ?.scrollIntoView({ behavior: "smooth" });
            setIsOpen(false);
          }}
        >
          Leadership
        </a>
        <a
          onClick={() => {
            document
              .getElementById("services")
              ?.scrollIntoView({ behavior: "smooth" });
            setIsOpen(false);
          }}
        >
          Services
        </a>
      </div>

      <div className={styles.menu_icon} onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </div>
    </nav>
  );
};

export default Navbar;
